import type { FC, ReactElement } from 'react';

import { IconRoot } from '@pp/core/src/components/icons/iconRoot';

import { LauncherContextProvider } from '../../context/LauncherContext';
import { LauncherInitialiser } from '../launcherInitialiser/LauncherInitialiser';
import { LauncherLayout } from '../layout/LauncherLayout';

export const LauncherRoot: FC = (): ReactElement => {
  return (
    <>
      <IconRoot />
      <LauncherContextProvider>
        <LauncherInitialiser />
        <LauncherLayout />
      </LauncherContextProvider>
    </>
  );
};
